(function () {
  var form = document.getElementById("TracktechNetworkApplication");
  if (!form) return;
  var params = new URLSearchParams(window.location.search);
  var plan = params.get("plan") || params.get("tier") || "";
  var tier = document.getElementById("tt-network-tier");
  if (!tier || tier.value) return;
  if (plan === "field_tech" || plan === "installer") tier.value = "installer";
  if (plan === "partner_shop" || plan === "shop") tier.value = "partner_shop";
  if (plan === "dealer") tier.value = "dealer";
})();
